import { Box, Grid, IconButton } from '@mui/material';
import React from 'react';
import Text from './Text';
import InstagramIcon from '@mui/icons-material/Instagram';
import FacebookIcon from '@mui/icons-material/Facebook';
import EmailIcon from '@mui/icons-material/Email';
import theme from '../../theme';
import Images from '../../services/data/images';

const styles = {
  subFooter: {
    background: '#0B0D17',
    paddingTop: theme.spacing(1),
    paddingBottom: theme.spacing(1),
  },
  logo: {
    width: theme.spacing(17),
    height: theme.spacing(5),
    borderRadius: theme.spacing(1),
    border: '1px solid white',
  },
};

export default function SubFooter() {
  return (
    <Box style={styles.subFooter}>
      <Grid container alignItems="center" justifyContent="center">
        <Grid
          container
          item
          justifyContent="flex-end"
          alignItems="center"
          lg={3}
          gap={10}
        >
          <Text size="small" color="#FFFFFF">
            RenoMate
          </Text>
          <Text size="small" color="#FFFFFF">
            © 2021 RenoMate. All rights reserved
          </Text>
        </Grid>

        <Grid container item justifyContent="center" lg={4} gap={2}>
          <IconButton href="https://play.google.com/store/apps/details?id=com.manobin.ireno">
            <img alt="logo" style={styles.logo} src={Images.google_logo} />
          </IconButton>
          <IconButton href="https://apps.apple.com/au/app/renomate-home-diy/id1576616277">
            <img alt="logo" style={styles.logo} src={Images.apple_logo} />
          </IconButton>
        </Grid>

        <Grid container item justifyContent="center" gap={2} lg={3}>
          <IconButton href="https://www.instagram.com/renomate.app">
            <InstagramIcon fontSize="small" htmlColor="white" />
          </IconButton>

          <IconButton href="https://www.facebook.com/renomateAu/">
            <FacebookIcon fontSize="small" htmlColor="white" />
          </IconButton>

          <IconButton href="mailto:social@renomate.app">
            <EmailIcon fontSize="small" htmlColor="white" />
          </IconButton>
        </Grid>
      </Grid>
    </Box>
  );
}
